import { render, staticRenderFns } from "./AppealDetailDialog.vue?vue&type=template&id=f0df564e&scoped=true"
import script from "./AppealDetailDialog.vue?vue&type=script&lang=js"
export * from "./AppealDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./AppealDetailDialog.vue?vue&type=style&index=0&id=f0df564e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0df564e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DialogAppealConfirmDialog: require('/home/vsts/work/1/s/components/dialog/AppealConfirmDialog.vue').default})
